import { render, staticRenderFns } from "./LoserCoin.vue?vue&type=template&id=7c03b667&scoped=true"
import script from "./LoserCoin.vue?vue&type=script&lang=js"
export * from "./LoserCoin.vue?vue&type=script&lang=js"
import style0 from "./LoserCoin.vue?vue&type=style&index=0&id=7c03b667&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c03b667",
  null
  
)

export default component.exports